import { Box, BoxProps } from '@rover/kibble/core';
import useTheme from '@rover/kibble/themes/useTheme';

const Divider = (props: BoxProps): JSX.Element => {
  const { colors } = useTheme();

  return (
    <Box
      borderBottomWidth="1px"
      borderBottomStyle="solid"
      borderBottomColor={colors.separator.primary.toString()}
      {...props}
    />
  );
};

export default Divider;
